<script setup lang="ts">
type Props = {
  id: string;
  href?: string;
  src?: string;
  type: 'antillephone' | 'anjseal' | 'curacao' | 'ra-reputation' | 'image';
  size?: '256' | '128' | string;
};

const { id, href, src, type, size = '256' } = defineProps<Props>();

const imageType = computed<string>(() => {
  return size === '256' ? 'basic-light-large' : 'basic-small';
});
</script>
<template>
  <div
    v-if="type === 'antillephone'"
    :id="`apg-${id}`"
    :data-apg-image-size="size"
    :data-apg-image-type="imageType"
    :data-apg-seal-id="id"
    :style="{ width: `${size}px` }"
  >
  </div>
  <div
    v-if="type === 'anjseal'"
    :id="`anj-${id}`"
    :data-anj-image-size="size"
    :data-anj-image-type="imageType"
    :data-anj-seal-id="id"
    :style="{ width: `${size}px` }"
  >
  </div>
  <a
    v-if="type === 'ra-reputation'"
    class="bg-white border border-solid border-[#a4c929] gap-1.5 rounded-[6px] w-[137px] h-[48px] flex justify-center items-center"
    :href="href"
    rel="noopener"
    target="_blank"
  >
    <img
      alt="Empresa RA1000 pelo Selo Reclame AQUI"
      fetchpriority="high"
      height="36"
      :src="getAssetsUrlForCDN('/assets/images/seals/ra-1000.svg')"
      style="height: auto; width: 36px"
      title="RA 1000"
      width="36"
    />
    <div>
      <div class="text-[13px] font-semibold text-[#4b5963]">RA 1000</div>
      <img
        alt="Selo Reclame Aqui"
        fetchpriority="high"
        height="13"
        :src="getAssetsUrlForCDN('/assets/images/seals/reclame-aqui-logo.svg')"
        style="height: 12.75px; width: 80px"
        width="80"
      />
    </div>
  </a>
  <div
    v-if="type === 'image'"
    style="display: inline-flex"
    :style="{ width: `${size}px` }"
  >
    <a
      v-if="href"
      :href="href"
      rel="noopener"
      target="_blank"
    >
      <img
        v-if="src"
        :alt="id || ''"
        class="m-auto w-full h-auto"
        :height="size"
        :src="getAssetsUrlForCDN(src)"
        :width="size"
      />
    </a>
    <img
      v-else-if="src"
      :alt="id || ''"
      class="m-auto w-full h-auto"
      :height="size"
      :src="getAssetsUrlForCDN(src)"
      :width="size"
    />
  </div>
</template>
